enum ManagerTagEndpoints {
  getMany = "/tags",
  create = "/tags",
}

export default ManagerTagEndpoints;
